/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import { generatePlaceholderImage } from "./placeholderImage";
import { useGetVideoThumbnailPresignedUrl } from "./useGetVideoThumbnailPresignedUrl";

import type { VideoData } from "./types";
import type { Cookie } from "@spwn/types/functions";

type VideoThumbnailButtonProps = {
  video: VideoData;
  cookie: Cookie;
  isCurrentVideo: boolean;
  handleSwitchMultiAngleVideo: (videoId: string) => void;
};

export const ThumbnailPreview: React.FC<VideoThumbnailButtonProps> = ({
  video,
  cookie,
  isCurrentVideo,
  handleSwitchMultiAngleVideo,
}) => {
  const handleClick = () => {
    handleSwitchMultiAngleVideo(video.videoId);
  };

  const thumbnailUrl = useGetVideoThumbnailPresignedUrl(cookie);

  return (
    <button
      style={{ padding: 0, textAlign: "left", position: "relative" }}
      onClick={handleClick}
    >
      {isCurrentVideo && (
        <span
          style={{
            position: "absolute",
            top: "10px",
            right: "11px",
            backgroundColor: "white",
            color: "black",
            padding: "2px 6px",
            borderRadius: "4px",
            fontWeight: "bold",
            fontSize: "12px",
            lineHeight: "16px",
          }}
        >
          再生中
        </span>
      )}
      <img
        src={thumbnailUrl ?? generatePlaceholderImage(video.name)}
        alt={video.name}
        style={{
          width: "192px",
          fontSize: "16px",
          height: "auto",
          display: "block",
          marginBottom: "8px",
          borderRadius: "4px",
        }}
      />
      <span style={{ color: "white", marginLeft: "4px" }}>{video.name}</span>
    </button>
  );
};
